import useCursor from '@src/hooks/useCursor';

function ForceCursor({ cursor }: { cursor: string }) {
  useCursor(cursor);

  return null;
}

export default ForceCursor;
